module.exports = [
	{
		"value": 1,
		"label": "I don't currently have broadband"
	},
	{
		"value": 2,
		"label": "Spark"
	},
	{
		"value": 3,
		"label": "Vodafone"
	},
	{
		"value": 4,
		"label": "2degrees"
	},
	{
		"value": 5,
		"label": "MyRepublic"
	},
	{
		"value": 6,
		"label": "Sky"
	},
	{
		"value": 7,
		"label": "Orcon"
	},
	{
		"value": 8,
		"label": "Slingshot"
	},
	{
		"value": 9,
		"label": "Flip"
	},
	{
		"value": 10,
		"label": "Contact"
	},
	{
		"value": 11,
		"label": "Trustpower"
	},
	{
		"value": 12,
		"label": "Mercury"
	},
	{
		"value": 13,
		"label": "Now"
	},
	{
		"value": 14,
		"label": "Nova"
	},
	{
		"value": 15,
		"label": "Compass"
	},
	{
		"value": 16,
		"label": "Voyager"
	},
	{
		"value": 17,
		"label": "Wireless nation"
	},
	{
		"value": 18,
		"label": "Hostshot"
	},
	{
		"value": 19,
		"label": "Megatel"
	},
	{
		"value": 20,
		"label": "Electric Kiwi"
	},
	{
		"value": 21,
		"label": "Bigpipe"
	},
	{
		"value": 22,
		"label": "I don't know"
	},
	{
		"value": 23,
		"label": "Other"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/checkout/CurrentConnection/isps.json
 ** module id = 481
 ** module chunks = 0
 **/